<template>
  <main id="personalBar" :class="{ 'out-of-screen': !isOpened }">
    <!-- Team selection component -->
    <!-- <TeamSelection v-if="teamSelectionShow" @close="teamSelectionShow=false" /> -->

    <!-- Bar content -->
    <header>
      <h1 class="title">Personal Profile</h1>
    </header>

    <!-- Team info -->
    <section class="personal-content hub-grey">
      <div
        :class="{
          'icon-circle': true,
          clickable: true,
          hovered: loginUser.teamCount > 1,
        }"
      >
        <img
          v-if="loginUser.teamLogoImage"
          class="team-logo"
          :src="$utils.conversion.toServerUrl(loginUser.teamLogoImage)"
          alt=""
        />
        <inline-svg v-else :src="$assets.svg['missing-team']" width="100%" height="100%" />
      </div>

      <p class="identity">{{ loginUser.firstName + ' ' + loginUser.lastName }}</p>
      <p class="team-name" v-if="loginUser.teamName">({{ loginUser.teamName }})</p>
    </section>

    <!-- Spliter -->
    <hr />

    <!-- Service type -->

    <!-- Personal record menu -->
    <section class="personal-menu">
      <ol>
        <li
          v-for="learningType in learningTypeList"
          :key="learningType.learning_type_key"
          class="personal-menu-item"
          :class="{
            'hub-link': learningType.learning_type_status === 'available',
            disabled: learningType.learning_type_status !== 'available',
            active: learningType.learning_type_key === learningTypeKey,
          }"
          @click="setLearningTypeKey(learningType)"
          @keypress.enter="setLearningTypeKey(learningType)"
        >
          <a>{{ learningType.name }}</a>
        </li>
      </ol>
    </section>

    <!-- Personal Bar Toggle button -->
    <div class="toggle-btn clickable" @click="isOpened = !isOpened" @keypress.enter="isOpened = !isOpened">
      <p class="circle" />
      <p class="circle" />
      <p class="circle" />
    </div>
  </main>
</template>

<script>
// import TeamSelection from '@/components/facilitator/TeamSelection';

export default {
  data() {
    return {
      isOpened: true,
      teamHovered: false,
      teamSelectionShow: false,
      learningTypeList: [],

      learningTypes: ['Youth Learning', 'Adult Learning', 'Facilitator Training'],
    };
  },

  async created() {
    const data = await this.$api.get('/learning-types');
    this.learningTypeList = data.records.filter((r) => Number(r.is_record_menu) === 1);
  },

  methods: {
    setLearningTypeKey(learningType) {
      if (learningType.learning_type_key === this.learningTypeKey) return;
      if (learningType.learning_type_status !== 'available') return;

      this.isOpened = false;
      this.$router.push({ path: learningType.learning_type_key });
    },
  },
  computed: {
    loginUser() {
      return this.$store.getters.loginUser;
    },
    learningTypeKey() {
      return this.$route.path.split('/').pop();
    },
  },

  // components: {
  //   TeamSelection,
  // },
};
</script>

<style scoped>
#personalBar {
  display: flex;
  flex-flow: column;
  align-items: center;
  position: fixed;
  top: 0;
  right: 0;
  margin: 0;

  box-sizing: border-box;
  width: min(60%, 18em);
  height: 100%;
  border-left: 2px solid #a7a9ac;
  padding-top: 1em;

  background: #fff;
  transition: right 0.3s;
}
#personalBar.out-of-screen {
  right: max(-60%, -18em);
}

.personal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.icon-circle {
  margin: 1em 0;
  width: 5em;
  height: 5em;
  border: 1px solid #a7a9ac;
  border-radius: 50%;
  padding: 0.8em;

  transition: background-color 0.3s;
}
.icon-circle .team-logo {
  width: 100%;
}

.identity,
.team-name {
  box-sizing: border-box;
  margin: 1em 0;
  width: 100%;
  padding: 0 10%;
  text-align: center;
}

hr {
  margin-top: 1em;
  width: 90%;
  height: 1px;
  border: 0 none;
  background: #a7a9ac;
}

.personal-menu {
  position: absolute;
  bottom: 0;
  right: 0;
  margin: 0;
  padding: 0;
  width: 100%;
}
.personal-menu-item {
  border-top: 1px solid #fff;
  padding: 1.8em 0;
  background: #a7a9ac;
  color: #fff;
  text-align: center;
  transition: background-color 0.3s;
}
:not(.disabled).personal-menu-item:hover,
:not(.disabled).personal-menu-item.active {
  background-color: #8ac640;
}
.personal-menu-item.disabled {
  color: #ccc;
  cursor: default;
}

.toggle-btn {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: space-evenly;

  position: absolute;
  left: calc(-1.2em - 2px);
  top: 0.5em;

  box-sizing: border-box;
  height: 2.8em;
  width: 1.2em;
  border-radius: 0.4em 0 0 0.4em;
  padding: 0.4em 0;
  background: #8ac640;
}
.circle {
  margin: 0;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #fff;
}

/** Landscape mobile */
@media only screen and (orientation: landscape) and (max-height: 600px) {
  h1.title {
    margin: 0;
  }

  .icon-circle {
    margin: 1em 0 0;
    width: 3em;
    height: 3em;
    padding: 0.5em;
  }

  .identity {
    margin: 1em 0;
  }
  .team-name {
    margin: 0;
  }

  hr {
    display: none;
  }

  .personal-menu-item {
    padding: 1em 0;
    text-align: center;
  }
}
</style>
